module.exports = __webpack_public_path__ + "html/subscription-invoice-history-container_f2302383f0fcfd294127ccb395d0aaf3.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription/containers/subscription-invoice-history-container.html
// module id = jGt4
// module chunks = 64